export enum ParceriasRodas {
  DEALER
}
